import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "roles-container"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "avatar-container"
};
const _hoisted_5 = {
  class: "nickname"
};
const _hoisted_6 = {
  class: "role-progress-container"
};
const _hoisted_7 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_8 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_9 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_10 = {
  class: "role-data-container"
};
const _hoisted_11 = {
  class: "role-reset-container"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import { computed, ref, onMounted } from 'vue';
import { ElButton, ElCol, ElImage, ElProgress, ElRow } from 'element-plus';
import 'element-plus/es/components/progress/style/css';
import { getPercentage, inApostleType } from "@/tools/utils";
import store from "@/store"; // pre-declaration

export default {
  __name: 'StatusUpdater',
  props: {
    data: {
      type: Object,
      required: true
    },
    actor: {
      type: Array,
      required: true
    }
  },
  emits: ['submitUpdates', 'clickRole', 'resetRole', 'reloadRole'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const selectedRolesIds = ref([]);
    const updates = ref({});
    const resetReminder = ref(null);
    const resetRoleId = ref(null);
    const resetMode = ref(null); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const dataArray = computed(() => {
      if (!props.data || !props.actor) return [];
      const roleDataKeys = Object.keys(props.data);
      if (roleDataKeys.length < props.actor.length) return [];
      return props.actor.map(role => {
        let role_status = props.data[role.id].role_status ?? {};

        if (selectedRolesIds.value.includes(role.id)) {
          role_status = Object.fromEntries(Object.entries(role_status).map(([key, value]) => {
            if (key.endsWith('hp') || key.endsWith('mp') || key.endsWith('san')) {
              return [key, value + updates.value[key]];
            } else {
              return [key, value];
            }
          }));
        }

        return { ...{
            'ticket': role
          },
          ...{
            'role_status': role_status
          }
        };
      });
    }); // functions

    const clickRole = role => {
      if (!inApostleType(userType.value)) return;
      const roleId = role.ticket.id;
      const index = selectedRolesIds.value.indexOf(roleId);

      if (index !== -1) {
        selectedRolesIds.value.splice(index, 1);
      } else {
        selectedRolesIds.value.push(roleId);
      }
    };

    const getAdjustMythology = roleId => {
      if (!selectedRolesIds.value.includes(roleId)) return '';
      if (!updates.value || !updates.value.mythology || updates.value.mythology === 0) return '';

      if (updates.value.mythology > 0) {
        return ` + ${updates.value.mythology}`;
      }

      return ` - ${Math.abs(updates.value.mythology)}`;
    };

    const getAdjustWealthPoint = roleId => {
      if (!selectedRolesIds.value.includes(roleId)) return '';
      if (!updates.value || !updates.value.wealth_point || updates.value.wealth_point === 0) return '';

      if (updates.value.wealth_point > 0) {
        return ` + ${updates.value.wealth_point.toFixed(1)}`;
      }

      return ` - ${Math.abs(updates.value.wealth_point).toFixed(1)}`;
    };

    const resetUpdates = () => {
      updates.value = {
        'hp': 0,
        'mp': 0,
        'san': 0,
        'max_hp': 0,
        'max_mp': 0,
        'max_san': 0,
        'mythology': 0,
        'wealth_point': 0
      };
    };

    const submitUpdates = () => {
      const buffer = Object.fromEntries(Object.entries(updates.value).filter(([, value]) => value !== 0).map(([key, value]) => {
        if (key === 'wealth_point') {
          return [key, value.toFixed(1)];
        }

        return [key, value];
      })); // console.log('submitUpdates', JSON.stringify(buffer))

      const data = {
        'role_ids': selectedRolesIds.value,
        'updates': buffer
      };
      emits('submitUpdates', data);
    };

    const preApplication = (event, roleId, mode) => {
      event.stopPropagation();
      resetRoleId.value = roleId;
      resetMode.value = mode;
      resetReminder.value = true; // emits('resetRole', role.ticket.id, 'init')
    };

    const reloadRoleData = (event, roleId) => {
      event.stopPropagation();
      emits('reloadRole', roleId);
    };

    const clearApplication = () => {
      resetRoleId.value = null;
      resetMode.value = null;
      resetReminder.value = false;
    };

    const submitApplication = () => {
      emits('resetRole', resetRoleId.value, resetMode.value);
      clearApplication();
    }; // lifecycle


    onMounted(() => {
      resetUpdates();
    });
    return (_ctx, _cache) => {
      const _component_el_slider = _resolveComponent("el-slider");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (role, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["role-card", selectedRolesIds.value.includes(role.ticket.id) ? 'isSelected' : '']),
          key: index,
          onClick: $event => clickRole(role)
        }, [_createVNode(_unref(ElCol), {
          class: "role-status-container"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElImage), {
            src: role.ticket.avatar,
            fit: "cover",
            draggable: "false"
          }, null, 8, ["src"])]), _createElementVNode("text", _hoisted_5, _toDisplayString(role.ticket.nickname), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.hp, role.role_status.max_hp),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress hp_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_7, " HP：" + _toDisplayString(`${role.role_status.hp} / ${role.role_status.max_hp}`), 1)]),
            _: 2
          }, 1032, ["percentage"]), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.mp, role.role_status.max_mp),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress mp_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_8, " MP：" + _toDisplayString(`${role.role_status.mp} / ${role.role_status.max_mp}`), 1)]),
            _: 2
          }, 1032, ["percentage"]), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.san, role.role_status.max_san),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress san_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_9, " SAN：" + _toDisplayString(`${role.role_status.san} / ${role.role_status.max_san}`), 1)]),
            _: 2
          }, 1032, ["percentage"])])]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_10, [_createElementVNode("text", null, " 神话 / " + _toDisplayString(role.role_status.mythology) + " " + _toDisplayString(getAdjustMythology(role.ticket.id)), 1), _createElementVNode("text", null, " 资产 / " + _toDisplayString(role.role_status.wealth_point) + " " + _toDisplayString(getAdjustWealthPoint(role.ticket.id)), 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElButton), {
          onClick: $event => preApplication($event, role.ticket.id, 'init')
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 状态重置至演出开始 ", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_unref(ElButton), {
          onClick: $event => preApplication($event, role.ticket.id, 'prev')
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 状态重置至上次快照 ", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_unref(ElButton), {
          onClick: $event => reloadRoleData($event, role.ticket.id)
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" 重载角色数据 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])])], 10, _hoisted_3);
      }), 128))]), _createVNode(_unref(ElRow), {
        class: "updater-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          offset: 1,
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "HP（" + _toDisplayString(updates.value.hp) + "）：", 1), _createVNode(_component_el_slider, {
              class: "hp-slider",
              modelValue: updates.value.hp,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updates.value.hp = $event),
              min: -50,
              max: 50,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "MP（" + _toDisplayString(updates.value.mp) + "）：", 1), _createVNode(_component_el_slider, {
              class: "mp-slider",
              modelValue: updates.value.mp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updates.value.mp = $event),
              min: -50,
              max: 50,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "SAN（" + _toDisplayString(updates.value.san) + "）：", 1), _createVNode(_component_el_slider, {
              class: "san-slider",
              modelValue: updates.value.san,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updates.value.san = $event),
              min: -100,
              max: 100,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row",
            style: {
              "margin-top": "10px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "资产点数（" + _toDisplayString(updates.value.wealth_point?.toFixed(1)) + "）：", 1), _createVNode(_component_el_slider, {
              class: "resources-slider",
              modelValue: updates.value.wealth_point,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updates.value.wealth_point = $event),
              min: -50,
              max: 50,
              precision: 1,
              step: 0.1
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 1,
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "上限HP（" + _toDisplayString(updates.value.max_hp) + "）：", 1), _createVNode(_component_el_slider, {
              class: "max-hp-slider",
              modelValue: updates.value.max_hp,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updates.value.max_hp = $event),
              min: -50,
              max: 50,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "上限MP（" + _toDisplayString(updates.value.max_mp) + "）：", 1), _createVNode(_component_el_slider, {
              class: "max-mp-slider",
              modelValue: updates.value.max_mp,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updates.value.max_mp = $event),
              min: -50,
              max: 50,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row"
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "上限SAN（" + _toDisplayString(updates.value.max_san) + "）：", 1), _createVNode(_component_el_slider, {
              class: "max-san-slider",
              modelValue: updates.value.max_san,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => updates.value.max_san = $event),
              min: -100,
              max: 100,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "update-item-row",
            style: {
              "margin-top": "10px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "神话知识（" + _toDisplayString(updates.value.mythology) + "）：", 1), _createVNode(_component_el_slider, {
              class: "mythology-slider",
              modelValue: updates.value.mythology,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updates.value.mythology = $event),
              min: -20,
              max: 20,
              step: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "operator-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: resetUpdates
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" 重置调整数值 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          onClick: submitUpdates
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" 提交调整数值 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: resetReminder.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => resetReminder.value = $event),
        title: "重置状态确认",
        width: "800",
        onClose: clearApplication
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_unref(ElButton), {
          onClick: submitApplication
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" 确认 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: clearApplication
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(resetMode.value === 'init' ? '重置状态至演出开始，意味着完全覆盖角色的当前舞台数据，恢复至初始化状态，确认重置吗？' : '重置状态至上次快照，意味着完全覆盖角色的当前舞台数据，恢复至上一次记录快照的状态，确认重置吗？'), 1)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};